import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import { Form } from "antd"

import { DOMINIO_SERVIDOR, URL_BACKEND } from "../../api/url"
import { elToast } from "../../functions/alertas"
import { extencionImagen } from "../../data/datos"

const useEditarPregunta = () => {

    // variables
    //? el pk_materia no se usa
    // const { id:pk_materia, id_pregunta:pks } = useParams()
    const { id_pregunta:pks } = useParams()
    var indice1 = pks.split('-')
    // var indice1 = [244, 41]
    const id_pregunta = indice1[0]
    const [form] = Form.useForm()

    const [urlImagen, setUrlImagen] = useState( null )
    const [img, setImg] = useState( null )
    const [extencion, setExtencion] = useState('')
    const [imagenAnterior, setImagenAnterior] = useState()

    const [respuestas, setRespuestas ] = useState([])

    // funciones
    const traerPregunta = () => {
        
        let body = new FormData()
        body.append( 'funcion', 'traerPreguntaIndividual' )
        body.append( 'pk_pregunta', id_pregunta )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {
            
            if ( d[0].imagen?.length > 0 ) {
                let url = DOMINIO_SERVIDOR + "/img/examen/" + d[0].imagen
    
                setUrlImagen( url )
                setImagenAnterior( d[0].imagen )
    
                document.querySelector( '#imgPruebaEdit' ).src = url
            } else {
                let img = document.querySelector('#imgPruebaEdit');
                img.parentNode.removeChild(img)
            }

            form.setFieldsValue({
                pregunta: d[0].pregunta
            })

        })
        .catch( () => alert("Error en el servidor") )

    }

    const guardar = values => {

        var imagen = ( img ) ? img : false

        let body = new FormData()
        body.append( 'funcion', 'actualizarPregunta' )
        body.append( 'id_pregunta', id_pregunta )
        body.append( 'imagen', imagen );
        body.append( 'extencion', extencion );
        body.append( 'imagenAnterior', imagenAnterior );
        body.append( 'pregunta', values.pregunta )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {
            
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                elToast( d.mensaje )
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
        .catch( () => alert("Error en el servidor") )

    }

    const onChange = e => {
        // const archivos = $seleccionArchivos.files;
        
        if ( e.target.value ) {

            const archivo = e.target.files[0]
            
            var nombreDividido = archivo.name.split(".")
            var tipo = nombreDividido[ nombreDividido.length-1 ]
            tipo = tipo.toLowerCase()

            if ( extencionImagen.includes( tipo ) ) {

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => setImg(f.target.result)
                setExtencion( tipo )
                const objectURL = URL.createObjectURL( archivo );
                document.querySelector( '#imgPruebaEdit' ).src = objectURL
    
            } else {
                setImg( null )
                alert("Sólo se permiten imágenes")
            }
        }

    }

    const borrarImagen = () => {
        // document.querySelector( '#textareaPregunta' ).value = ''
        document.querySelector( '#imgPruebaEdit' ).src = ''
        document.querySelector( '#inputFileEdit' ).value = ''
        setImg( null )
        setExtencion('')

        let body = new FormData()
        body.append( 'funcion', 'borrarImagen' )
        body.append( 'id_pregunta', id_pregunta )
        body.append( 'imagenAnterior', imagenAnterior )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {
            
            // eslint-disable-next-line
            if ( d.codigo == 1 ) {
                elToast( d.mensaje )
                // eslint-disable-next-line
            } else if( d.codigo == 2 ) {
                // nada
            } else {
                elToast( d.mensaje, 'error' )
            }

        })
        // .catch( () => alert("Error en el servidor") )

    }

    const traerOpciones = () => {
        
        let body = new FormData()
        body.append( 'funcion', 'traerOpciones' )
        body.append( 'pk_pregunta', id_pregunta )

        fetch( URL_BACKEND, {
            method: 'post',
            body
        })
        .then( r => r.json() )
        .then( d => {

            setRespuestas(d);

        })
        // .catch( () => alert("Error en el servidor") )

    }

    const actualizarContenidoRespuesta = (respuesta, pk_respuestas) => {

        let nuevaRespuesta = prompt("Nueva respuesta", respuesta);

        if(nuevaRespuesta != null && nuevaRespuesta.length > 0){

            let body = new FormData()
            body.append( 'funcion', 'actualizarRespuesta' )
            body.append( 'pk_respuestas', pk_respuestas )
            body.append( 'respuesta', nuevaRespuesta )

            fetch( URL_BACKEND, {
                method: 'post',
                body
            })
            .then( r => r.json() )
            .then( d => {

                //validar codigo respuesta
                // eslint-disable-next-line
                if(d.codigo == 1){
                    elToast(d.mensaje);
                    traerOpciones();
                }else{
                    elToast(d.mensaje, "error");
                }

            })
            .catch( () => alert("Error en el servidor") )
        }
    }

    const cambiarRespuestaCorrecta = (pk_respuestas, fk_pregunta) => {

        let body = new FormData();
        body.append("funcion", "cambiarRespuestaCorrecta");
        body.append("pk_respuestas", pk_respuestas);
        body.append("fk_pregunta", fk_pregunta);

        fetch(URL_BACKEND, {
            method: "post",
            body,
        })
        .then((r) => r.json())
        .then((d) => {

            // eslint-disable-next-line
            if (d.codigo == 1) {
                elToast(d.mensaje);
                traerOpciones();
            } else {
                elToast(d.mensaje, "error");
            }

        })
        .catch(() => alert("Error en el servidor"));

    }

    // useEffects
    useEffect(() => {
        traerPregunta()
        traerOpciones()
        // eslint-disable-next-line
    }, [])
    

    return {
        respuestas,
        actualizarContenidoRespuesta,
        cambiarRespuestaCorrecta,
        guardar,
        form,
        urlImagen,
        onChange,
        borrarImagen
    }
}

export default useEditarPregunta
